module.exports = __webpack_public_path__ + "static/media/bidon_default.1116a734.png";